import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, TipoComunidad, SaveTipoComunidadDto, SearchTipoComunidadRequest, TipoComunidadEnum } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class TipoComunidadService extends CrudService<TipoComunidad, number, SaveTipoComunidadDto, SearchTipoComunidadRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'tipoComunidad', sharedFunctions);

  }

  getTipos(): Observable<GenericResponse<TipoComunidadEnum[]>> {
    return this._http.get<GenericResponse<TipoComunidadEnum[]>>(this._serviceUrl + '/tipos-enum', this.httpOptions);
  }
}